import { axiosClient } from "../api/axios";

export const postSolicitud = async (data) => {
    try {
        const res = await axiosClient.post("/solicitud", data, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        });
        return res;
      } catch (error) {
        console.log(error);
        return error;
      }  
};